import type { OrderPlaybackConfig } from '@order/features/ordering';

export const getOrderPlaybackConfig = (
  config?: Record<string, number>,
  isRedesignEnabled?: boolean,
): OrderPlaybackConfig => {
  // Legacy order playback config.
  // To be removed together with CELS-4719-order-playback-redesign-enabled.
  const locationFadeIn = config?.locationFadeIn ?? 1000;
  const timeFadeIn = config?.timeFadeIn ?? 2000;
  const orderDetailsFadeIn = config?.orderDetailsFadeIn ?? 3000;
  const lineItemsFadeIn = config?.lineItemsFadeIn ?? 4000;
  const confirmationFadeIn = config?.confirmationFadeIn ?? 8000;
  const legacyPlaybackDuration = lineItemsFadeIn + confirmationFadeIn;

  // The sum of these three being the total duration of order playback.
  // First the header fades in, then the body, then the timer runs.
  const playbackHeaderFadeDuration = config?.playbackHeaderFadeDuration ?? 1000;
  const playbackBodyFadeDuration = config?.playbackBodyFadeDuration ?? 1000;
  const playbackTimerDuration = config?.playbackTimerDuration ?? 3000;
  const playbackTotalDuration =
    playbackHeaderFadeDuration +
    playbackBodyFadeDuration +
    playbackTimerDuration;

  const orderSubmissionDelay = isRedesignEnabled
    ? playbackTotalDuration
    : legacyPlaybackDuration;

  return {
    locationFadeIn,
    timeFadeIn,
    orderDetailsFadeIn,
    lineItemsFadeIn,
    confirmationFadeIn,
    orderSubmissionDelay,
    playbackHeaderFadeDuration,
    playbackBodyFadeDuration,
    playbackTimerDuration,
  };
};
